// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__gpf0P","crumb":"Breadcrumbs_crumb__rhCl_"};